import { BookingAttempt, BookingAttemptMetrics } from 'model/BookingAttempt';
import { BookingAttemptsPagination } from 'reducers/bookingAttempts/BookingAttemptsState';
import { Action } from 'redux';

export const BOOKING_ATTEMPTS_RESET_ACTION_TYPE = 'booking_attempts/reset';

type BookingAttemptsResetAction = Action<typeof BOOKING_ATTEMPTS_RESET_ACTION_TYPE>;

export const BOOKING_ATTEMPTS_ERROR_ACTION_TYPE = 'booking_attempts/error';

type BookingAttemptsErrorAction = Action<typeof BOOKING_ATTEMPTS_ERROR_ACTION_TYPE>;

export const BOOKING_ATTEMPTS_FETCH_START_ACTION_TYPE = 'booking_attempts/fetch_start';

type BookingAttemptsFetchStartAction = Action<typeof BOOKING_ATTEMPTS_FETCH_START_ACTION_TYPE>;

export const BOOKING_ATTEMPTS_FETCH_SUCCESS_ACTION_TYPE = 'booking_attempts/fetch_success';

interface BookingAttemptsFetchSuccessAction extends Action<typeof BOOKING_ATTEMPTS_FETCH_SUCCESS_ACTION_TYPE> {
    payload: {
        bookingAttempts: Array<BookingAttempt>;
        pagination: BookingAttemptsPagination;
    };
}

export const BOOKING_ATTEMPTS_METRICS_FETCH_START_ACTION_TYPE = 'booking_attempts/metric_fetch_start';

type BookingAttemptsMetricsFetchStartAction = Action<typeof BOOKING_ATTEMPTS_METRICS_FETCH_START_ACTION_TYPE>;

export const BOOKING_ATTEMPTS_METRICS_FETCH_SUCCESS_ACTION_TYPE = 'booking_attempts/metric_fetch_success';

interface BookingAttemptsMetricsFetchSuccessAction
    extends Action<typeof BOOKING_ATTEMPTS_METRICS_FETCH_SUCCESS_ACTION_TYPE> {
    payload: {
        metrics: BookingAttemptMetrics;
    };
}

export type BookingAttemptsAction =
    | BookingAttemptsResetAction
    | BookingAttemptsErrorAction
    | BookingAttemptsFetchStartAction
    | BookingAttemptsFetchSuccessAction
    | BookingAttemptsMetricsFetchStartAction
    | BookingAttemptsMetricsFetchSuccessAction;
